import React from "react";
import mapx444yum from "../assets/img/newmap.png";

const HoveredMap = () => {
  const pins = [
    { top: "49%", left: "59%", text: "United Arab Emirates" },
    { top: "43%", left: "56.5%", text: "Iraq" },
    { top: "49%", left: "56.3%", text: "Saudi Arabia" },
    { top: "43%", left: "54.8%", text: "Israel" },
    { top: "41.5%", left: "76%", text: "Japan" },
    { top: "64%", left: "62%", text: "Maldives" },
    { top: "48%", left: "58%", text: "Qatar" },

    // { top: "45%", left: "57.5%", text: "Kuwait" },
    // { top: "45%", left: "57.5%", text: "Kuwait" },
    // { top: "45%", left: "57.5%", text: "Kuwait" },

  ];

  return (
    <div>
      <div className="map-container">
        <img
          src={mapx444yum}
          alt="World Map"
          className="map-image"
        />

        {pins.map((pin, index) => (
          <div
            key={index}
            className="pin"
            style={{ top: pin.top, left: pin.left }}
          >
            <span className="tooltip">{pin.text}</span>
          </div>
        ))}
      </div>
      <style jsx>{`

        .map-container {
          position: relative;
          display: inline-block;
        }

        .map-image {
          width: 100%;
          max-width: 1200px;
          display: block;
        }

        .pin {
          position: absolute;
          width: 1.1rem;
          height: 1.5rem;
          // background: red;
          // opacity:0.5;



          background: transperent;
          border-radius: 50%;
          cursor: pointer;
          transform: translate(-50%, -50%);
        }

        .tooltip {
          visibility: hidden;
          // background-color: #333;
          background-color: #0f1138;
          color: #fff;
          text-align: center;
          padding: 6px 10px;
          border-radius: 5px;
          position: absolute;
          z-index: 10;
          bottom: 125%;
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          transition: opacity 0.3s;
          white-space: nowrap;
          font-size: 1.5rem;
        }

        .pin:hover .tooltip {
          visibility: visible;
          opacity: 1;
        }
      `}</style>      
    </div>

  );
};

export default HoveredMap;
